"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _core = require("@dnd-kit/core");

var _sortable = require("@dnd-kit/sortable");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useDraggableTable = function useDraggableTable(_ref) {
  var setData = _ref.setData,
      disableReorder = _ref.disableReorder,
      state = _ref.state,
      onReorder = _ref.onReorder,
      data = _ref.data,
      rows = _ref.rows,
      prepareRow = _ref.prepareRow;
  var dataRef = (0, _react.useRef)(data);
  var stateRef = (0, _react.useRef)(state);
  var sensors = (0, _core.useSensors)((0, _core.useSensor)(_core.MouseSensor, {}), (0, _core.useSensor)(_core.TouchSensor, {}), (0, _core.useSensor)(_core.KeyboardSensor, {}));

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dragRowId = _useState2[0],
      setDragRowId = _useState2[1];

  var handleDragStart = (0, _react.useCallback)(function (event) {
    setDragRowId(event.active.id);
  }, []);
  var handleDragEnd = (0, _react.useCallback)(function (event) {
    var active = event.active,
        over = event.over;

    if (active.id !== over.id) {
      setData(function (list) {
        return (0, _sortable.arrayMove)(list, list.indexOf(list.find(function (r) {
          return r.id === active.id;
        })), list.indexOf(list.find(function (r) {
          return r.id === over.id;
        })));
      });

      if (onReorder) {
        var oldIndex = active.data.current.sortable.index;
        var newIndex = over.data.current.sortable.index;
        var items = active.data.current.sortable.items;
        onReorder(_objectSpread(_objectSpread({}, event), {}, {
          oldIndex: oldIndex,
          newIndex: newIndex,
          orderedIds: (0, _sortable.arrayMove)(items, items.indexOf(active.id), items.indexOf(over.id))
        }), dataRef.current[oldIndex], stateRef.current);
      }
    }

    setDragRowId(null);
  }, [onReorder, setData]);
  var handleDragCancel = (0, _react.useCallback)(function () {
    setDragRowId(null);
  }, []);
  var selectedRow = (0, _react.useMemo)(function () {
    if (!dragRowId) {
      return null;
    }

    var row = rows.find(function (_ref2) {
      var original = _ref2.original;
      return original.id === dragRowId;
    });
    prepareRow(row);
    return row;
  }, [dragRowId, rows, prepareRow]);
  var noReorder = (0, _react.useMemo)( // Can't reorder when the table is sorted,
  // disableReorder is set to true
  // or is searching
  function () {
    return !!state.sortBy.length || disableReorder || !!state.globalFilter || !!state.filters.length;
  }, [state.sortBy, disableReorder, state.globalFilter, state.filters]);
  (0, _react.useEffect)(function () {
    dataRef.current = data;
  }, [data]);
  (0, _react.useEffect)(function () {
    stateRef.current = state;
  }, [state]);
  return {
    noReorder: noReorder,
    sensors: sensors,
    handleDragStart: handleDragStart,
    handleDragEnd: handleDragEnd,
    handleDragCancel: handleDragCancel,
    dragRow: selectedRow,
    dragRowId: dragRowId
  };
};

var _default = useDraggableTable;
exports["default"] = _default;
//# sourceMappingURL=useDraggableTable.js.map